/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GetAdminActivitiesKpiResponse { 
    /**
     * Total number of activities in the system, including cancelled.
     */
    totalActivities: number;
    /**
     * Activities created during the current UTC calendar month.
     */
    activitiesCreatedThisMonth: number;
    /**
     * Unique users present in attendees across all activities (not pendingInvitees).
     */
    totalParticipants: number;
    /**
     * Activities with status scheduled or in_progress.
     */
    incoming: number;
    /**
     * Percentage of finished activities over all activities (0–100, rounded).
     */
    completionRate: number;
    /**
     * Current UTC month completion rate minus previous UTC month completion rate (by startDate month).
     */
    completionRateDelta: number;
}

